export enum MLSearchType {
  PLP = "PLP",
  SAYT = "SAYT",
  SRLP = "SRLP"
}
